import { console } from 'react-redux-app/lib/modules/core/utils';

import {
  SESSION_STORAGE,
  getItem,
  removeItem,
} from 'react-redux-app/lib/modules/storage';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';

import { STORAGE_KEY__REDIRECT_AFTER_LOGIN_URL } from '../../../auth/constants';


export default ({ getState, dispatch }) => (
  function checkRedirectAfterLoginUrlHandler(nextState, successCallback, errorCallback) {
    try {
      const redirectAfterLoginUrl = getItem(
        SESSION_STORAGE,
        STORAGE_KEY__REDIRECT_AFTER_LOGIN_URL
      );

      if (redirectAfterLoginUrl) {
        removeItem(SESSION_STORAGE, STORAGE_KEY__REDIRECT_AFTER_LOGIN_URL);
        errorCallback(redirectAfterLoginUrl);
        return;
      }

      successCallback();
    } catch (e) {
      console.consoleError('checkRedirectAfterLoginUrlHandler failed', e);
      errorCallback(INTERNAL_ERROR_URI);
    }
  }
);
